// orchestratorSync.ts — Panel sync from LangGraph /chat (focus + refresh_lists).
// Called by chatbotLangGraph.tsx. Not used by LangGraph chat_test.html dev page.
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { applyOrchestratorFocus } from './orchestratorFocus';
function normalizeFocus(payload) {
    var _a;
    return (_a = payload.ui_focus) !== null && _a !== void 0 ? _a : payload.focus;
}
function normalizeRefreshLists(payload) {
    var _a, _b;
    return (_b = (_a = payload.ui_refresh) !== null && _a !== void 0 ? _a : payload.refresh_lists) !== null && _b !== void 0 ? _b : [];
}
function parseNumericId(value) {
    if (value === undefined || value === null || value === '')
        return null;
    const n = typeof value === 'number' ? value : parseInt(String(value), 10);
    return Number.isNaN(n) ? null : n;
}
// ── List refresh helpers (call the same logic as manual Launch) ─────────────
function refreshReceptorsList(focus) {
    return __awaiter(this, void 0, void 0, function* () {
        const receptorID = parseNumericId(focus === null || focus === void 0 ? void 0 : focus.receptorID);
        const syncOne = window.syncReceptorFromAgent;
        if (receptorID && syncOne) {
            yield syncOne(receptorID);
            return;
        }
        const loadAll = window.loadSessionReceptors;
        if (loadAll)
            yield loadAll();
    });
}
function refreshPeptidesList(focus) {
    return __awaiter(this, void 0, void 0, function* () {
        const peptideID = parseNumericId(focus === null || focus === void 0 ? void 0 : focus.peptideID);
        const syncOne = window.syncPeptideFromAgent;
        if (peptideID && syncOne) {
            yield syncOne(peptideID);
            return;
        }
        const { loadSessionPeptides } = yield import('./components/peptideForm');
        yield loadSessionPeptides();
    });
}
function refreshDockingsList(focus) {
    return __awaiter(this, void 0, void 0, function* () {
        var _a;
        const dockingID = (_a = focus === null || focus === void 0 ? void 0 : focus.dockingID) === null || _a === void 0 ? void 0 : _a.trim();
        const syncOne = window.syncDockingFromAgent;
        if (dockingID && syncOne) {
            yield syncOne(dockingID);
            return;
        }
        const { loadSessionDockings } = yield import('./components/dockingForm');
        yield loadSessionDockings();
    });
}
function refreshList(listName, focus) {
    return __awaiter(this, void 0, void 0, function* () {
        switch (listName) {
            case 'receptors':
                yield refreshReceptorsList(focus);
                break;
            case 'peptides':
                yield refreshPeptidesList(focus);
                break;
            case 'dockings':
                yield refreshDockingsList(focus);
                break;
            default:
                console.warn('[orchestratorSync] Unknown refresh_lists entry:', listName);
        }
    });
}
// ── Ensure focused items exist in DOM even without refresh_lists hint ───────
function syncFocusedItems(focus, refreshed) {
    return __awaiter(this, void 0, void 0, function* () {
        var _a;
        const receptorID = parseNumericId(focus.receptorID);
        const peptideID = parseNumericId(focus.peptideID);
        const dockingID = (_a = focus.dockingID) === null || _a === void 0 ? void 0 : _a.trim();
        if (receptorID && !refreshed.has('receptors')) {
            const sync = window.syncReceptorFromAgent;
            if (sync)
                yield sync(receptorID);
        }
        if (peptideID && !refreshed.has('peptides')) {
            const sync = window.syncPeptideFromAgent;
            if (sync)
                yield sync(peptideID);
        }
        if (dockingID && !refreshed.has('dockings')) {
            const sync = window.syncDockingFromAgent;
            if (sync)
                yield sync(dockingID);
        }
    });
}
/**
 * Main entry: process /chat response on the MexaScreen panel.
 * Call from the LangGraph chat component when a message includes ui_focus / ui_refresh.
 */
export function applyOrchestratorChatSync(payload) {
    return __awaiter(this, void 0, void 0, function* () {
        const focus = normalizeFocus(payload);
        const refreshLists = normalizeRefreshLists(payload);
        console.log('[orchestratorSync] Chat sync:', { focus, refreshLists });
        const refreshed = new Set();
        // Step 1 — refresh lists (creates rows + updates status, like manual Launch)
        for (const listName of refreshLists) {
            yield refreshList(listName, focus);
            refreshed.add(listName);
        }
        // Step 2 — if focus points at an item but its list was not refreshed, sync that item alone
        if (focus) {
            yield syncFocusedItems(focus, refreshed);
        }
        // Step 3 — select + scroll
        if (focus) {
            yield applyOrchestratorFocus(focus);
        }
    });
}
